// extracted by mini-css-extract-plugin
export default {"SamplePoints":"SamplePoints_SamplePoints__4n0z9","search":"SamplePoints_search__b+ERx","inputLabel":"SamplePoints_inputLabel__1MSM8"};